import * as React from "react";
const SvgFiRrDiagramVenn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16 4c-1.46 0-2.82.39-4 1.07A7.97 7.97 0 0 0 8 4c-4.41 0-8 3.59-8 8s3.59 8 8 8c1.46 0 2.82-.39 4-1.07 1.18.68 2.54 1.07 4 1.07 4.41 0 8-3.59 8-8s-3.59-8-8-8m-5.19 11h2.39c-.32.55-.72 1.05-1.19 1.47-.47-.42-.88-.92-1.19-1.47zM12 7.53c.47.42.88.92 1.19 1.47H10.8c.32-.55.72-1.05 1.19-1.47zM10 12c0-.34.03-.67.08-1h3.83c.05.33.08.66.08 1s-.03.67-.08 1h-3.83c-.05-.33-.08-.66-.08-1m-8 0c0-3.31 2.69-6 6-6 .8 0 1.56.16 2.25.44A7.98 7.98 0 0 0 8 12c0 2.16.86 4.12 2.25 5.56-.7.28-1.46.44-2.25.44-3.31 0-6-2.69-6-6"
    />
  </svg>
);
export default SvgFiRrDiagramVenn;
